<div
    *ngIf="!inView()"
    class="st-assignment-item-content-container"></div>
<div
    *ngIf="inView()"
    class="st-assignment-item-border-left"
    st-left-border
    [data]="data()"></div>
@switch (cardViewType()) {
    @case (CardViewTypes.SMALL) {
        <ng-container *ngTemplateOutlet="smallCard" />
    }
    @case (CardViewTypes.MEDIUM) {
        <ng-container *ngTemplateOutlet="mediumCard" />
    }
    @default {
        <ng-container *ngTemplateOutlet="largeCard" />
    }
}
<ng-template #largeCard>
    <div
        *ngIf="inView()"
        class="st-assignment-item-content-container"
        [class.st-assignment-item-content-container__mouse-entered]="mouseEntered"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()">
        <div class="st-assignment-item-content-container__static">
            <div class="st-assignment-item-content-container-main">
                <div class="st-assignment-item-content-container-main-top-row">
                    <st-assignment-type
                        showLabel
                        showIcon="false"
                        [data]="data()"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.DescriptionType]"
                        [value]="data()?.PSTCoverageType"
                        (changed)="updateAssignment($event, pstFieldNames.DescriptionType)" />
                    @if (!data()?.isNewRecord) {
                        <span class="st-assignment-item-content-container-main__time-updated">{{ timeUpdatedLabel }}</span>
                        <span class="st-assignment-item-content-container-main__updated-by">{{ updatedBy }}</span>
                    }
                </div>
                <st-text-area-overlay
                    required
                    class="st-assignment-item-content-container-main-top-row__slug"
                    minRows="1"
                    minHeight="1rem"
                    maxLength="50"
                    disableNewLine
                    panelClass="st-assignment-item-content-container-main__slug"
                    [textToHighlight]="searchString()"
                    [value]="data()?.Title"
                    [disabled]="cardDisabled()"
                    [placeholder]="languageSettings.PSTWebSlugPlaceholder"
                    (changed)="updateAssignment($event, pstFieldNames.Title)" />
                <st-text-area-overlay
                    class="st-assignment-item-content-container-main__summary"
                    minRows="3"
                    minHeight="3rem"
                    panelClass="st-assignment-item-content-container-main__summary"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.Description]?.Required"
                    [value]="data()?.Description"
                    [textToHighlight]="searchString()"
                    [disabled]="cardDisabled()"
                    [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.Description]?.DefaultCaption"
                    (changed)="updateAssignment($event, pstFieldNames.Description)" />
                <st-tags-autocomplete
                    maxItemsToShow="5"
                    [value]="data()?.Tags"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTags]?.Required"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTags]"
                    [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTags]?.DefaultCaption"
                    (changed)="updateAssignment($event, pstFieldNames.PSTTags)" />
            </div>
            <div class="st-assignment-item-content-container-meta">
                <div class="st-assignment-item-content-container-meta__row">
                    <st-date-time-picker
                        *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Validation?.toUpperCase() === FieldDefValidations.TIME; else datePicker"
                        class="st-assignment-item-content-container-meta__date-picker"
                        asCustomField
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.TargetPublicationDate]"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Required"
                        [label]="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.DefaultCaption"
                        [value]="data()?.PSTTargetDate"
                        (onTimezoneChanged)="timezoneChanged(pstFieldNames?.TargetPublicationDate, $event)"
                        (changed)="updateAssignment($event, pstFieldNames.TargetPublicationDate)" />
                    <ng-template #datePicker>
                        <st-date-picker
                            class="st-assignment-item-content-container-meta__date-picker"
                            [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Required"
                            [label]="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.DefaultCaption"
                            [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.TargetPublicationDate]"
                            [value]="data()?.PSTTargetDate"
                            (changed)="updateAssignment($event, pstFieldNames.TargetPublicationDate)" />
                    </ng-template>
                    <st-status
                        class="st-assignment-item-content-container-meta__status"
                        [value]="data()?.PSTAssignmentStatus"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTAssignmentStatus]"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentStatus]?.Required"
                        [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentStatus]?.DefaultCaption"
                        [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTAssignmentStatus)"
                        (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentStatus)" />
                    <div class="st-assignment-item-content-container-actions">
                        <button
                            *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.AssignmentProp"
                            class="st-assignment-item-content-container-actions__approve"
                            mat-icon-button
                            [disabled]="cardDisabled()"
                            [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.DefaultCaption"
                            [class.st-assignment-item-content-container-actions__approve--active]="data()?.PSTApproved"
                            (click)="updateAssignment(!data()?.PSTApproved, pstFieldNames.PSTApproved)">
                            <mat-icon>done</mat-icon>
                        </button>
                        <button
                            *ngIf="isPublication()"
                            mat-icon-button
                            class="st-assignment-item-content-container-actions__delete"
                            [disabled]="cardDisabled()"
                            (click)="deletePublication($event)">
                            <mat-icon>delete_outline</mat-icon>
                        </button>

                        <button
                            class="st-assignment-item-content-container-actions__fullscreen"
                            mat-icon-button
                            [disabled]="isReadOnly()"
                            [matTooltip]="displayOpenActionButtonHoverTitle()"
                            (click)="assignmentOpenEmitter.emit()">
                            <mat-icon>fullscreen</mat-icon>
                        </button>
                        <div *ngIf="!isPublication()">
                            <st-external-actions-overlay
                                [inSidecarOpened]="inSidecarOpenedMode()"
                                [data]="data()"
                                [editable]="editable()"
                                [inFullScreen]="inFullscreenMode"
                                [onDelete]="assignmentDeleteEmitter"
                                [disabled]="cardDisabled()"
                                [onObjectOpen]="assignmentOpenEmitter" />
                        </div>
                    </div>
                </div>
                <div class="st-assignment-item-content-container-meta__row">
                    <st-desk
                        class="st-assignment-item-content-container-assigns__desk"
                        [value]="data()?.PSTGroup"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.Required"
                        [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.DefaultCaption"
                        [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.DefaultCaption"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTDesk]"
                        [itemList]="deskList()"
                        (changed)="updateAssignment($event, pstFieldNames.PSTDesk)" />
                </div>
                <div class="st-assignment-item-content-container-meta__row">
                    <st-staff-id-list
                        class="st-assignment-item-content-container-assigns__owners"
                        [value]="data()?.PSTAssignmentOwner"
                        [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentOwner]?.DefaultCaption"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTAssignmentOwner]"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentOwner]?.Required"
                        (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentOwner)" />
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #mediumCard>
    <div
        *ngIf="inView()"
        class="st-assignment-item-content-container__medium"
        [class.st-assignment-item-content-container__mouse-entered]="mouseEntered"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()">
        <div class="st-assignment-item-content-container__medium__left-column">
            <st-assignment-type
                showLabel
                showIcon="false"
                [data]="data()"
                [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.DescriptionType]"
                [value]="data()?.PSTCoverageType"
                (changed)="updateAssignment($event, pstFieldNames.DescriptionType)" />
            <div class="st-assignment-item-content-container__medium__main-content">
                <st-text-area-overlay
                    required
                    class="st-assignment-item-content-container-main-top-row__slug"
                    minRows="1"
                    minHeight="1rem"
                    maxLength="50"
                    maxRows="1"
                    disableNewLine
                    panelClass="st-assignment-item-content-container-main__slug"
                    [textToHighlight]="searchString()"
                    [value]="data()?.Title"
                    [disabled]="cardDisabled()"
                    [placeholder]="languageSettings.PSTWebSlugPlaceholder"
                    (changed)="updateAssignment($event, pstFieldNames.Title)" />
                <st-text-area-overlay
                    class="st-assignment-item-content-container-main__summary"
                    maxRows="2"
                    minHeight="2rem"
                    panelClass="st-assignment-item-content-container-main__summary"
                    [value]="data()?.Description"
                    [textToHighlight]="searchString()"
                    [disabled]="cardDisabled()"
                    [required]="globalTablesService.FieldDefsDict[pstFieldNames?.Description]?.Required"
                    [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.Description]?.DefaultCaption"
                    (changed)="updateAssignment($event, pstFieldNames.Description)" />
            </div>
            <div class="st-assignment-item-content-container__medium__metadata">
                <st-desk
                    class="st-assignment-item-content-container-assigns__desk"
                    [value]="data()?.PSTGroup"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.Required"
                    [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.DefaultCaption"
                    [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.DefaultCaption"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTDesk]"
                    [itemList]="deskList()"
                    [maxItemsToShow]="0"
                    (changed)="updateAssignment($event, pstFieldNames.PSTDesk)" />
                <st-staff-id-list
                    class="st-assignment-item-content-container-assigns__owners"
                    [value]="data()?.PSTAssignmentOwner"
                    [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentOwner]?.DefaultCaption"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTAssignmentOwner]"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentOwner]?.Required"
                    [maxItemsToShow]="0"
                    (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentOwner)" />
            </div>
        </div>
        <div class="st-assignment-item-content-container__medium__right-column">
            <div
                class="st-assignment-item-content-container-main__time-updated-by"
                [title]="timeUpdatedByLabel">
                {{ timeUpdatedByLabel }}
            </div>
            <st-date-time-picker
                *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Validation?.toUpperCase() === FieldDefValidations.TIME; else datePicker"
                class="st-assignment-item-content-container-meta__date-picker"
                asCustomField
                [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.TargetPublicationDate]"
                [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Required"
                [label]="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.DefaultCaption"
                [value]="data()?.PSTTargetDate"
                (onTimezoneChanged)="timezoneChanged(pstFieldNames?.TargetPublicationDate, $event)"
                (changed)="updateAssignment($event, pstFieldNames.TargetPublicationDate)" />
            <ng-template #datePicker>
                <st-date-picker
                    class="st-assignment-item-content-container-meta__date-picker"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Required"
                    [label]="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.DefaultCaption"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.TargetPublicationDate]"
                    [value]="data()?.PSTTargetDate"
                    (changed)="updateAssignment($event, pstFieldNames.TargetPublicationDate)" />
            </ng-template>
            <div class="st-assignment-item-content-container__medium__right-column__status">
                <st-status
                    class="st-assignment-item-content-container-meta__status"
                    [value]="data()?.PSTAssignmentStatus"
                    [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTAssignmentStatus]"
                    [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentStatus]?.Required"
                    [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentStatus]?.DefaultCaption"
                    [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTAssignmentStatus)"
                    (changed)="updateAssignment($event, pstFieldNames.PSTAssignmentStatus)" />
                <button
                    *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.AssignmentProp"
                    class="st-assignment-item-content-container-actions__approve"
                    mat-icon-button
                    [disabled]="cardDisabled()"
                    [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.DefaultCaption"
                    [class.st-assignment-item-content-container-actions__approve--active]="data()?.PSTApproved"
                    (click)="updateAssignment(!data()?.PSTApproved, pstFieldNames.PSTApproved)">
                    <mat-icon>done</mat-icon>
                </button>
                @if (!isPublication()) {
                    <st-external-actions-overlay
                        class="st-assignment-item-content-container-actions__external"
                        [inSidecarOpened]="inSidecarOpenedMode()"
                        [data]="data()"
                        [editable]="editable()"
                        [inFullScreen]="inFullscreenMode"
                        [onDelete]="assignmentDeleteEmitter"
                        [disabled]="cardDisabled()"
                        [onObjectOpen]="assignmentOpenEmitter" />
                } @else {
                    <button
                        mat-icon-button
                        class="st-assignment-item-content-container-actions__delete"
                        [disabled]="cardDisabled()"
                        (click)="deletePublication($event)">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                }
                <button
                    class="st-assignment-item-content-container-actions__fullscreen"
                    mat-icon-button
                    [disabled]="isReadOnly()"
                    [matTooltip]="displayOpenActionButtonHoverTitle()"
                    (click)="assignmentOpenEmitter.emit()">
                    <mat-icon>fullscreen</mat-icon>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #smallCard>
    <div
        *ngIf="inView()"
        class="st-assignment-item-content-container__mobile">
        <div class="st-assignment-item-content-container__mobile--top-row">
            <div
                class="st-assignment-item-content-container__mobile--status"
                [class.st-assignment-item-content-container__mobile--status-required]="
                    enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentStatus]?.Required && !data()?.PSTAssignmentStatus
                ">
                {{ data()?.PSTAssignmentStatus || globalTablesService.FieldDefsDict[pstFieldNames.PSTAssignmentStatus]?.DefaultCaption }}
            </div>
        </div>
        <div
            class="st-assignment-item-content-container__mobile--slug"
            [class.st-assignment-item-content-container__mobile--slug-required]="
                enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.Title]?.Required && !data()?.Title
            ">
            {{ data()?.Title || globalTablesService.FieldDefsDict[pstFieldNames.Title]?.DefaultCaption }}
        </div>

        <div class="st-assignment-item-content-container__mobile--desk">
            <mat-icon
                class="st-assignment-item-content-container__mobile--desk__icon"
                [class.st-assignment-item-content-container__mobile--desk__icon-required]="
                    enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.Required && !data()?.PSTGroup
                ">
                business
            </mat-icon>
            <span
                class="st-assignment-item-content-container__mobile--desk__text"
                [class.st-assignment-item-content-container__mobile--desk__text-required]="
                    enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.Required && !data()?.PSTGroup
                ">
                {{
                    getItemString(pstFieldNames.PSTDesk, itemStringCache, i18n(), globalTablesService, data(), getInnerProp, highlightPipe, searchString(), clientTimeZone()?.id, currentTimeZone()?.id)
                }}</span
            >
        </div>

        <div class="st-assignment-item-content-container__mobile--owner">
            <mat-icon
                class="st-assignment-item-content-container__mobile--owner__icon"
                [class.st-assignment-item-content-container__mobile--owner__icon-required]="
                    enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentOwner]?.Required && !data()?.PSTAssignmentOwner
                ">
                people
            </mat-icon>

            <span
                class="st-assignment-item-content-container__mobile--owner__text"
                [class.st-assignment-item-content-container__mobile--owner__text-required]="
                    enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentOwner]?.Required && !data()?.PSTAssignmentOwner
                "
                >{{
                    getItemString(
                        pstFieldNames.PSTAssignmentOwner,
                        itemStringCache,
                        i18n(),
                        globalTablesService,
                        data(),
                        getInnerProp,
                        highlightPipe,
                        searchString(),
                        clientTimeZone()?.id,
                        currentTimeZone()?.id
                    )
                }}</span
            >
        </div>

        <st-assignment-type
            *ngIf="data()"
            showLabel
            mediumIcon
            [disabled]="cardDisabled()"
            [data]="data()"
            [value]="data()?.PSTCoverageType"
            (changed)="updateAssignment($event, pstFieldNames.DescriptionType)" />
    </div>
</ng-template>
